import React, { useEffect } from 'react';
import { Button } from 'tea-component';
import { useIntl } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import AddCompare from '@op/pages/competitor/components/ComparisonCard/Components/AddCompare';
import { useCompareGameInfo } from '@op/pages/Compare/Compare/SameStartDate/hooks';
import { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

export default function GameSelectionSelect({
  gameInfo,
  filterOptions,
  onChange,
  changeOnCloseWindow,
}: SingleCommonType) {
  const { formatMessage } = useIntl();
  const {
    mainGame,
    originalGameList,
    competitorGame,
    changeCompetitorGame,
    loading,
    visible,
    setVisible,
  } = useCompareGameInfo({
    gameInfo: gameInfo as any,
    defaultValue: filterOptions,
  });

  useEffect(() => {
    onChange?.(
      'gameSelection',
      commonBackInfo(
        { gameSelection: competitorGame },
        { gameSelection: competitorGame },
      ),
    );
    changeOnCloseWindow?.({ gameSelection: competitorGame });
  }, [competitorGame]);

  return (
    <div className="game-section-select-wrapper">
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
          buriedBtnPoint('SelectGame');
        }}
      >
        <SvgIcon type="icon_add_game" />
        {formatMessage({ id: 'Game Selection' })}
      </Button>

      {visible && (
        <AddCompare
          visible={visible}
          mainGame={mainGame}
          selected={originalGameList}
          close={() => setVisible(false)}
          selectedLoading={loading}
          confirm={(targetList: any[]) => {
            changeCompetitorGame(targetList);
          }}
        />
      )}
    </div>
  );
}
